// extracted by mini-css-extract-plugin
export default {"info":"info_info__frAaj","info-button":"info_info-button__b1tTS","info-text":"info_info-text__-sefb"};